import { Typography } from '@material-ui/core'

import Title from 'components/Title'

type ConfirmationProps = {
  supportTicketCreated?: boolean
  pending?: boolean
  collegeName?: string
}

const Confirmation = ({ supportTicketCreated, pending, collegeName = 'your institution' }: ConfirmationProps) => {
  if (pending) {
    return (
      <>
        <Title title="Request Pending" />
        <Typography variant="body2">
          {`Your request to join ${collegeName} is still pending approval. Keep an eye on your inbox for an approval email.`}
        </Typography>
      </>
    )
  }

  return (
    <>
      <Title title="Request Submitted!" />
      <Typography variant="body2">
        {supportTicketCreated
          ? `We've submitted your request to our Support team. Keep an eye on your inbox for an email.`
          : `We've notified the admin at ${collegeName} of your request. Keep an eye on your inbox for an approval email.`}
      </Typography>
    </>
  )
}

export default Confirmation
